import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Download, Check, Gift } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function OfferBlock() {
  return <section id="oferta" className="py-24 bg-cream-dark/50 relative overflow-hidden" data-id="element-203">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-white/40 blur-3xl rounded-full pointer-events-none" data-id="element-204"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-205">
        <FadeIn data-id="element-206">
          <div className="bg-white rounded-[3rem] shadow-soft p-8 md:p-16 border border-white text-center" data-id="element-207">
            <h2 className="text-3xl md:text-5xl font-bold text-brown-dark mb-6" data-id="element-208">
              Recupera tus noches de sueño
            </h2>
            <p className="text-xl text-brown/80 font-serif mb-10" data-id="element-209">
              Transforma tus noches en solo 48 horas.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-210">
              <div className="text-center" data-id="element-211">
                <span className="text-sm font-bold text-accent uppercase tracking-wider mb-2 block" data-id="element-212">
                  Precio Especial
                </span>

                <div className="text-6xl md:text-7xl font-bold text-brown-dark font-serif" data-id="element-213">
                  $6,39
                </div>
              </div>

              <div className="text-left space-y-3" data-id="element-214">
                <div className="flex items-center gap-3" data-id="element-215">
                  <Check className="w-5 h-5 text-accent" data-id="element-216" />
                  <span className="text-brown-dark/80" data-id="element-217">
                    Acceso inmediato a la Guía
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-218">
                  <Check className="w-5 h-5 text-accent" data-id="element-219" />
                  <span className="text-brown-dark/80" data-id="element-220">
                    Todas las herramientas y plantillas
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-221">
                  <Check className="w-5 h-5 text-accent" data-id="element-222" />
                  <span className="text-brown-dark/80" data-id="element-223">
                    Bonus exclusivos incluidos
                  </span>
                </div>
              </div>
            </div>

            {/* Bonos Incluidos */}
            <div className="bg-cream/30 rounded-3xl p-8 mb-12 border-2 border-accent/20" data-id="element-224">
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-225">
                <Gift className="w-6 h-6 text-accent" data-id="element-226" />
                <h3 className="text-2xl font-bold text-brown-dark" data-id="element-227">
                  3 Bonos Gratis Incluidos
                </h3>
              </div>

              <div className="space-y-4 mb-6" data-id="element-228">
                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-229">
                  <div className="flex items-start justify-between gap-4" data-id="element-230">
                    <div className="flex items-start gap-3" data-id="element-231">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-232" />
                      <div data-id="element-233">
                        <h4 className="font-bold text-brown-dark" data-id="element-234">
                          Kit S.O.S. "Calma en 5 Minutos"
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-235">
                          Protocolo de emergencia nocturna
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-236">
                  <div className="flex items-start justify-between gap-4" data-id="element-237">
                    <div className="flex items-start gap-3" data-id="element-238">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-239" />
                      <div data-id="element-240">
                        <h4 className="font-bold text-brown-dark" data-id="element-241">
                          Guión Anti-Discusión Nocturna
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-242">
                          Para coordinación de pareja
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-5 border border-cream-dark" data-id="element-243">
                  <div className="flex items-start justify-between gap-4" data-id="element-244">
                    <div className="flex items-start gap-3" data-id="element-245">
                      <Check className="w-5 h-5 text-accent flex-shrink-0 mt-1" data-id="element-246" />
                      <div data-id="element-247">
                        <h4 className="font-bold text-brown-dark" data-id="element-248">
                          Planner de Siestas "Aterrizaje Suave"
                        </h4>
                        <p className="text-sm text-brown/70" data-id="element-249">
                          Sistema flexible 0-12 meses
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center pt-4 border-t border-cream-dark" data-id="element-250">
                <p className="text-brown/70 mb-1" data-id="element-251">Valor real del paquete:</p>
                <div className="flex items-center justify-center gap-2" data-id="element-252">
                  <span className="text-xl line-through text-brown/40" data-id="element-253">
                    $47
                  </span>
                  <span className="text-base text-brown/70" data-id="element-254">hoy solo</span>
                  <span className="text-4xl font-bold text-accent" data-id="element-255">$6,39</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center" data-id="element-256">
              <Button href="https://tumundoequilibrado.com/cart/51096956993831:1" onClick={trackAddToCart} icon={<Download className="w-5 h-5" data-id="element-258" />} className="w-full md:w-auto md:px-12 py-5 text-xl mb-2" data-id="element-257">
                Descarga tu guía ahora
              </Button>
              <p className="text-base text-accent font-bold mb-2" data-id="element-259">
                y recibe tres bonos adicionales
              </p>
              <p className="text-sm text-brown/60 font-medium" data-id="element-260">
                Descanso para ti y tu bebé comienza hoy mismo.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}